var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "w-full h-full"
  }, [_c('pro-table', _vm._b({
    ref: "proTableRef",
    on: {
      "on-selection-change": _vm.handleSelectionChange
    }
  }, 'pro-table', _vm.config, false)), _c('identity-setting-drawer', {
    ref: "drawerRef"
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };